import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import clsx from "clsx";

//import CsatScore from "./CsatScore";
import BreakStatistics from "./ShowBreakStatistics";
import Productivity from "./ShowProductivity";
import CallStatistics from "./ShowCallStatistics";
import CustomDisposition from "./ShowCustomDisposition";
import Title from "../Wrappers/Title";	
import Callinfo from "./Callinfo";
import { getDateTime } from "../../helpers/utility";

import { makeStyles } from "@material-ui/core/styles";
import { Container, Grid, Paper, Select, MenuItem, Input,Divider } from "@material-ui/core";

//store
import * as actions from "../../store/actions/actionIndex";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
	},
	toolbar: {
		paddingInlineEnd: 24, // keep right padding when drawer closed
	},

	toolbarIcon: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		padding: "0 8px",
		...theme.mixins.toolbar,
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
	appBarShift: {
		marginInlineStart: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	menuButton: {
		marginInlineEnd: 36,
	},
	menuButtonHidden: {
		display: "none",
	},
	title: {
		flexGrow: 1,
	},
	drawerPaper: {
		position: "relative",
		whiteSpace: "nowrap",
		width: drawerWidth,
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	drawerPaperClose: {
		overflowX: "hidden",
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		width: theme.spacing(7),
		[theme.breakpoints.up("sm")]: {
			width: theme.spacing(9),
		},
	},
	appBarSpacer: theme.mixins.toolbar,
	content: {
		flexGrow: 1,
		height: "100%",
	},
	container: {
		maxWidth: "100%",
		width: "100%",
		padding: "0px",
	},
	paper: {
		padding: theme.spacing(2),
		display: "flex",
		overflow: "auto",
		flexDirection: "column",
	},
	fixedHeight: {
		height: 598,
	},
	topfixedHeight: {
		height: 281,
	},
	downfixedHeight: {
		height: 310,
	},
	GridStatus: {
		display: "inline-block",
		padding: "5px",
		margin: "0",
	},
	DayDropDown: {
		position: "absolute",
		insetInlineEnd: "40px",
		top: "80px",
		color: "black",
		width: "120px",
		[theme.breakpoints.down("md")]: {
      		top: "100px",
    	},
    	[theme.breakpoints.down("xs")]: {
      		top: "85px",
    	},
	},
	DaySelect: {
		// backgroundColor: "white",
		marginInlineStart: "40px",
		width: "110px",
		height: "30px",
		color: "black",
		borderRadius: "7%",
		fontSize: "13px",
		border: "groove",
		borderWidth: "thin",
		borderColor: "lightgray",
		textDecoration: "none",
		paddingInlineStart: "6px",
	},
}));


function ReportPage(props) {
	const classes = useStyles();
	const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
	const topheightPaper = clsx(classes.paper, classes.topfixedHeight);
	const downheightPaper = clsx(classes.paper, classes.downfixedHeight);
	const [value, setValue] = useState("Today");
	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const { agentId, onCallData, SelectedCN,agentState } = props;
	useEffect(() => {
		if (SelectedCN != null) {
			const getData = () => {
				const { startDate, endDate } = getDateTime(value, SelectedCN); 
				setStartDate(startDate);
				setEndDate(endDate);
				onCallData(agentId, startDate, endDate); 
			};
			getData();
			// const getCallData = setInterval(getData, 3000);
			// return () => {
			// 	clearInterval(getCallData);
			// };
		}
	}, [agentId, onCallData, value, SelectedCN, startDate, endDate, agentState]);

	const handleChange = (value) => {
		
		setValue(value);
		const { startDate, endDate } = getDateTime(value, SelectedCN); 
		setStartDate(startDate);
		setEndDate(endDate);
		onCallData(agentId, startDate, endDate);
	};
	

	return (
		<div className={classes.root}>
			<main className={classes.content}>
				<Container maxWidth="lg" className={classes.container}>
					<Grid container spacing={1}>
						<Container className={classes.GridStatus}>
							<div className={classes.DayDropDown}>
								<Select value={value} onChange={(e) => handleChange(e.target.value)} input={<Input disableUnderline classes={{ input: classes.selectInput }} />} className={classes.DaySelect}>
									<MenuItem value="Today">Today</MenuItem>
									<MenuItem value="Yesterday">Yesterday</MenuItem>
									{/*<MenuItem value="Week">This Week</MenuItem>
									<MenuItem value="Month">This Month</MenuItem>
									<MenuItem value="LastWeek">Last Week</MenuItem>
									<MenuItem value="LastMonth">Last Month</MenuItem>*/}
								</Select>
							</div>
						</Container>

						<Grid item xs={12} md={5} lg={5}>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={6} md={6} lg={6}>
									<Paper className={fixedHeightPaper}>
										<Title>Agent Call Info </Title>
										<Divider />
										<Callinfo posts={props.posts} agentState = {agentState}/>
									</Paper>
								</Grid>
								<Grid item xs={12} sm={6} md={6} lg={6}>
									<Paper className={fixedHeightPaper}>
										<Title>Custom Disposition</Title>
										<Divider />
										<CustomDisposition dispositions={props.dispositions} />
									</Paper>
								</Grid>
							</Grid>
						</Grid>

						<Grid item xs={12} md={7} lg={7}>
							<Grid container spacing={1}>
								<Grid item xs={12} md={12} lg={12}>
									<Grid container spacing={1}>
										<Grid item xs={12} sm={6} md={6} lg={6}>
											<Paper className={topheightPaper}>
												<Productivity posts={props.posts} agentState = {agentState}/>
											</Paper>
										</Grid>
										<Grid item xs={12} sm={6} md={6} lg={6}>
											<Paper className={topheightPaper}>
												<CallStatistics posts={props.posts}/>
											</Paper>
										</Grid>
										
									</Grid>
								</Grid>

								<Grid item xs={12} md={12} lg={12}>
									<Grid container spacing={2}>
										
										<Grid item xs={12} md={12} lg={12}>
											<Paper className={downheightPaper}>
												<BreakStatistics agentBreaks={props.agentBreaks} agentState = {agentState}/>
											</Paper>
										</Grid>
										{/*<Grid item xs={12} md={12} lg={12}>
											<Paper className={downheightPaper}>
												<CsatScore />
											</Paper>
								</Grid>*/}
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Container>
			</main>
		</div>
	);
}

const mapStateToProps = (state) => {
	return {
		agentBreaks: state.callData.agentBreaks,
		posts: state.callData.posts,
		loading: state.callData.loading,
		agentId: state.agentData.agentId,
		dispositions: state.callData.dispositions,
		SelectedCN: state.agentConfig.campConf.agentui_timezone,
		timezones: state.agentConfig.timezone,
		agentState: state.agentData.agentState,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onCallData: (agentId, startDate, endDate) => dispatch(actions.callData(agentId, startDate, endDate)),
		onAgentConfig: (agentId) => dispatch(actions.agentConfig(agentId)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportPage);
